import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "idCardFilled"
const IdCardFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M21 4.875C21.828 4.875 22.5 5.547 22.5 6.375V19.875C22.5 20.703 21.828 21.375 21 21.375H3C2.172 21.375 1.5 20.703 1.5 19.875V6.375C1.5 5.547 2.172 4.875 3 4.875zM8.625 14.25C6.799 14.25 5.832 15.076 5.345 15.941 5.11 16.361 4.992 16.778 4.935 17.087 4.904 17.243 4.89 17.373 4.882 17.467Q4.877 17.536 4.876 17.576L4.875 17.61V18H12.375V17.625H12 12.375V17.577L12.366 17.467C12.359 17.372 12.345 17.242 12.316 17.086 12.258 16.778 12.14 16.361 11.905 15.941 11.418 15.076 10.45 14.25 8.625 14.25M14.625 15.375C14.211 15.375 13.875 15.711 13.875 16.125S14.211 16.875 14.625 16.875H18.375C18.789 16.875 19.125 16.539 19.125 16.125S18.789 15.375 18.375 15.375zM14.625 12.375C14.211 12.375 13.875 12.711 13.875 13.125S14.211 13.875 14.625 13.875H18.375C18.789 13.875 19.125 13.539 19.125 13.125S18.789 12.375 18.375 12.375zM8.625 8.25C7.175 8.25 6 9.425 6 10.875S7.175 13.5 8.625 13.5 11.25 12.325 11.25 10.875 10.075 8.25 8.625 8.25M14.625 9.375C14.211 9.375 13.875 9.711 13.875 10.125S14.211 10.875 14.625 10.875H18.375C18.789 10.875 19.125 10.539 19.125 10.125S18.789 9.375 18.375 9.375z"
            clipRule="evenodd"
          />
          <path d="M12.75 2.25C13.164 2.25 13.5 2.586 13.5 3V3.75H10.5V3C10.5 2.586 10.836 2.25 11.25 2.25z" />
        </svg>
      }
    </span>
  )
}
export default IdCardFilledIcon
